import React from 'react'
import { Link } from 'react-router-dom'

import { useTranslation } from '@/features/locale/LocaleProvider'
import { Button } from '@/ui/button'

export function MobileHomeHero() {
  const t = useTranslation()

  return (
    <section className="mobile-app__hero-panic browse-home-hero text-center">
      <h1 className="browse-home-hero__title mobile-app__hero-panic-title">DON&apos;T PANIC</h1>
      <div className="browse-home-hero__subtitle-wrap">
        <p className="browse-home-hero__subtitle">{t.home.subtitle}</p>
      </div>
      <p className="browse-home-hero__lead">{t.home.lead}</p>
      <Link to="/swap" className="mt-6 inline-block w-full sm:w-auto">
        <Button size="lg" className="min-h-11 w-full sm:w-auto">
          {t.home.tryNutrimatic}
        </Button>
      </Link>
    </section>
  )
}
